import React, { useEffect, useState } from "react";
import CloseIcon from "../../../../../../../src/assets/images/icons/close_icon.svg";
import { withTranslation } from "react-i18next";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../../../../helpers/global_helper";
import { formatPrice } from "../../../../../NumberFormat";

const ReferralBonusDatePopup = (props) => {
  const { onClose, referralbonusDateId } = props
  const [referralbonusdatedata, setReferralBonusDateData] = useState([]);

  // api for Referral Bonus Date popup
  const fetchReferralBonusDateData = () => {
    let reqData = {
      date: referralbonusDateId,
    };
    makeAjax(url.PLAYER_API.getReferralBonus, reqData, url.PLAYER_MS_EXT).then((response) => {

      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server connection lost", "error", "not getting data");
          return;
        }
        showMessage("server connection lost ", "error", "not geeting data");
        return;
      }
      setReferralBonusDateData(response.data);
    });
  };

  useEffect(() => {
    if (referralbonusDateId) {
      fetchReferralBonusDateData();
    }
  }, [referralbonusDateId]);

  return (
    <div>
      <div className="info_popup_overlay"></div>
      <div className="info_popup">
        <div className="info_popup_header ">
          <button className="info_popup_close" onClick={onClose}>
            <img src={CloseIcon} alt="" />
          </button>
          <h2 className="info_popup_title">
            {props.t("information")} REFERRAL
          </h2>
          <div className="header_bottom_border"></div>
        </div>
        <div className="info_popup_body">
          <div className="info_popup_content">
            <table className="table_data data_table1">
              <thead>
                <tr>
                  <th>{props.t("nickname")}</th>
                  <th>{props.t("turnover")}</th>
                  <th> {props.t("commision")}</th>
                </tr>
              </thead>
              <tbody>
                {referralbonusdatedata === 0 ? (
                  <tr className="table_data_empty_row">
                    <td colSpan="3">{props.t("data_not_found")}</td>
                  </tr>
                ) : (
                  <tr className="first_bg">
                    <td>{referralbonusdatedata.nickname}</td>
                    <td>{formatPrice(referralbonusdatedata.turnover)}</td>
                    <td>{referralbonusdatedata.commission?parseFloat(referralbonusdatedata.commission).toFixed(2):""}</td> 
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ReferralBonusDatePopup);
